
import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { Trip } from '@/types/itinerary';
import AssistantChat from '@/components/assistant/AssistantChat';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Bot } from 'lucide-react';

interface TripContextType {
  trip: Trip;
  isAuthorized: boolean;
}

const Assistant: React.FC = () => {
  const { trip, isAuthorized } = useOutletContext<TripContextType>();

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-[#0A3D62] font-poppins mb-4">Travel Assistant</h2>
      
      <div className="grid grid-cols-1 gap-6">
        <AssistantChat trip={trip} />
      </div>
    </div>
  );
};

export default Assistant;
